(function($, _) {
  var ns = window.nspace("ccc.viz.map.layers");

  /**
   * "Static" class for managing polygon retrieval
   */

  ns.PolygonManager = {
    /**
     * Cache (polygons are stored in WKT form)
     */
    polygonsByLocType: {},

    /**
     * Global event dispatcher
     */
    dispatcher: window.ccc.viz.shared.VizApp.dispatcher,

    /**
     * Keep track of loading polygons
     */
    loadingDeferreds: {},

    /**
     * Loads the polygon data from the server side for the specified location type
     */
    loadPolygons: function(locationTypeId) {
      var self = this;

      // Do we already have a deferred object for this location type id?
      if (this.loadingDeferreds.hasOwnProperty(locationTypeId)) {
        return this.loadingDeferreds[locationTypeId];
      }

      // Trigger the load and return the deferred
      $(self).trigger("busy");
      self.dispatcher.trigger("add-task", {
        name: "loading-polygons",
        text: "Loading polygons..."
      });

      var deferred = $.ajax({
        url: "/api/MapData/GetWktPolygons",
        data: {
          locationTypeId: locationTypeId,
          isSimplified: true
        },
        complete: function() {
          $(self).trigger("idle");
          self.dispatcher.trigger("end-task", { name: "loading-polygons" });
        },
        success: function(response) {
          var polygons = {};

          // Parse out the WKT text into google API Polygons
          for (var key in response) {
            var wktPolygon = response[key];
            var polygon = ccc.viz.map.util.MapUtil.wktToGooglePolygon(
              wktPolygon
            );

            polygons[key] = polygon;
          }

          // Save for future use
          self.polygonsByLocType[locationTypeId] = polygons;
        }
      });

      // Record the deferred for future requests for these same polygons
      this.loadingDeferreds[locationTypeId] = deferred;
      return deferred;
    },

    clonePolygon: function(polygon) {
      var clone = new google.maps.Polygon();

      // Copy just the paths. Maybe not exactly a true clone, but in order to copy everything
      // properly we'd have to walk to full object graph and create new instances of all inner
      // reference-type properties. Copying just the paths will suffice for our purposes.
      clone.setPaths(polygon.getPaths());

      return clone;
    },

    /**
     * Returns a single google map API Polygon, via callback, based on the specified FIPS
     * and location type ID, or null if none is found.
     */
    getPolygonByFips: function(locationTypeId, fips, onSuccessCallback) {
      var self = this;

      $.when(this.loadPolygons(locationTypeId)).done(function() {
        var polygons = self.polygonsByLocType[locationTypeId];
        var polygon = polygons[fips];
        if (!polygon) {
          onSuccessCallback(null);
          return;
        }

        onSuccessCallback({ fips: fips, polygon: polygon });
      });
    },

    parsePolygon: function(text) {
      var paths = [];
      var rings = $.trim(text).split(regExes.parenComma);
      for (var i = 0, len = rings.length; i < len; ++i) {
        var ring = rings[i].replace(regExes.trimParens, "$1");
        paths.push(getPolygonLatLngs(ring));
      }

      return paths;
    },

    parseMultiPolygon: function(text) {
      var polygon;
      var polygons = $.trim(text).split(regExes.doubleParenComma);
      var paths = [];
      for (var i = 0, len = polygons.length; i < len; ++i) {
        polygon = polygons[i].replace(regExes.trimParens, "$1");
        var polyPaths = parsePolygon(polygon);
        for (var j = 0; j < polyPaths.length; j++) {
          paths.push(polyPaths[j]);
        }
      }
      return paths;
    },

    getPolygonLatLngs: function(coords) {
      // Expects polygon text that looks like this:
      // -12211621.104157 4438929.90942386, ... , -12212798.9101653 4438929.90942386

      // split into coord pairs
      var pairs = coords.split(", ");
      var latLngs = [];
      for (var i = 0; i < pairs.length; i++) {
        // create a new LatLng from each pair
        var parts = pairs[i].split(" ");
        var lat = parseFloat(parts[1]);
        var lng = parseFloat(parts[0]);

        latLngs.push(new google.maps.LatLng(lat, lng));
      }

      return latLngs;
    },

    /**
     * Returns the single google Maps API Polygon that sits underneath the specified mouse coordinates, for
     * the specified location type, or null if none is found
     */
    findPolygon: function(locationTypeId, latLng, onSuccessCallback) {
      var self = this;

      $.when(this.loadPolygons(locationTypeId)).done(function() {
        var polygons = self.polygonsByLocType[locationTypeId];
        for (var fips in polygons) {
          var polygon = polygons[fips];
          if (polygon.contains(latLng)) {
            onSuccessCallback({ fips: fips, polygon: polygon });
            return;
          }
        }

        onSuccessCallback(null);
      });
    }
  };
})(jQuery, _);
